export const invitations = {
  cta: {
    share: {
      data: {
        text: 'Salut ! Tu connais déjà Creative Shelter ? Je facture mes droits d’auteur via eux et je garde ainsi plus d’argent en poche. Tu veux essayer ? Facture gratuitement pendant 60 jours. (Il t’en reste donc encore plus !)',
        title: 'La plateforme de facturation de Creative Shelter',
      },
      permissionDenied: 'Vous devez donner votre autorisation pour pouvoir partager votre lien d’invitation.',
    },
    socials: {
      twitter: {
        hashtags: '#droitsdauteur #gagnerplus #creativeshelter',
        text: 'Hé, toi ! Tu connais déjà Creative Shelter ? Je facture mes droits d’auteur via eux et je garde ainsi plus d’argent en poche. Tu veux essayer ? Facture gratuitement pendant 60 jours !',
      },
    },
  },
  discount: {
    ariaLabel: 'Progression de la réduction : {{completed}} étapes sur {{total}} terminées',
  },
  discountProgress: {
    currentDiscount: 'Vous bénéficiez actuellement de {{percentage}} % de réduction',
    hint_one: 'Invitez encore {{count}} ami',
    hint_other: 'Invitez encore {{count}} amis',
    savedLabel: 'Vous avez déjà économisé',
    step: '{{percentage}} % de réduction sur votre commission',
  },
  hero: {
    buttons: {
      copyLink: 'Copier le lien',
      copyLinkSuccess: 'Copié !',
      email: 'Envoyer un e-mail',
      share: 'Partager',
    },
    description:
      'Envoyez votre lien personnel. Dès que votre ami ou collègue envoie sa première facture, vous recevez 25 % de réduction sur votre commission à Creative Shelter et votre ami facture gratuitement pendant 60 jours.',
    shareVia: 'ou partager via',
    socials: {
      facebook: 'Partager via Facebook',
      linkedin: 'Partager via LinkedIn',
      whatsapp: 'Partager via WhatsApp',
      x: 'Partager via X',
    },
    title: 'Invitez un ami et recevez une réduction',
  },
  howItWorks: {
    disclaimer:
      'La réduction de 25 % est valable un an et prend effet dès que la personne que vous avez invitée a envoyé une première facture, dans les 30 jours suivant la création de son compte. Pour la personne que vous invitez, la réduction prend effet immédiatement après la création de son compte.',
    steps: {
      earn: 'Vous gagnez 25 % de réduction par ami qui facture',
      invoice: 'Votre ami facture gratuitement pendant 60 jours',
      register: 'Votre ami s’inscrit avec votre lien personnel',
    },
    title: 'Comment ça marche ?',
  },
  sendInvitationDialog: {
    errors: {
      accountAlreadyExists: 'Ce freelance facture déjà via Creative Shelter. 🙌',
      noDoubleInvite: 'Vous avez déjà envoyé une invitation à cette adresse e-mail.',
      noSelfInvite: 'Vous ne pouvez pas vous inviter vous-même !',
      userAlreadyExists:
        'Ce freelance a déjà un compte chez Creative Shelter, mais ne facture pas encore. Parfois, il suffit d’un petit coup de pouce.',
    },
    form: {
      inviteeEmailAddressField: {
        label: 'Adresse e-mail',
      },
      inviteeFirstNameField: {
        label: 'Prénom',
      },
      inviteeLanguageField: {
        label: 'Langue',
      },
      inviteeLastNameField: {
        label: 'Nom de famille',
      },
      submitButton: 'Envoyer',
    },
    success: 'Votre invitation a été envoyée à {{ name }}.',
    title: 'Inviter quelqu’un',
  },
  sentInvitations: {
    headers: {
      email: 'E-mail',
      name: 'Nom',
      status: 'Statut',
    },
    status: {
      accepted: 'Inscrit',
      declined: 'Refusée',
      pending: 'En attente',
    },
    title: 'Invitations envoyées',
  },
  title: 'Inviter des amis',
};
